import React from 'react';
import { Icon } from '../Icon';
import { Tooltip } from '../Tooltip';

interface FieldHelpProps {
    content?: string | null;
    className?: string;
    iconClassName?: string;
    placement?: 'top' | 'bottom' | 'left' | 'right' | 'auto';
}

/**
 * Compact help control: info icon with tooltip for field/action explanations.
 * Uses a span (not a button) so it can sit inside clickable chips without nested buttons.
 */
const FieldHelp = (props: FieldHelpProps) => {
    const { content, className, iconClassName, placement } = props;

    if (!content)
        return null;

    return (
        <Tooltip content={content} placement={placement ?? 'top'} light>
            <span
                role="img"
                tabIndex={0}
                className={`inline-flex items-center justify-center align-middle text-gray-400 hover:text-gray-600 dark:text-gray-300 focus:outline-none cursor-help ${className || ''}`}
                aria-label={content}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }}
            >
                <Icon type="info" size={3} color="current" className={iconClassName} />
            </span>
        </Tooltip>
    );
};

export default FieldHelp;
